<template>
  <div class="InfiniteLoadingListContainer">
    <nut-infiniteloading
        :has-more="hasMore"
        @load-more="loadMore"
        @refresh="refresh"
        load-icon="loading"
        pull-icon="loading"
        :load-more-txt="loadMoreText"
        :is-open-refresh="true"
    >
      <template v-if="list && list.length > 0">
        <template v-for="(p,i) in list" :key="i">
          <slot :list="list" :data="p" :mapping="textMapping"
                :index="i" :last="!hasMore && i ==list.length-1"/>
        </template>
      </template>
      <nut-row class="pt32 wd100 bothCenter" v-else>
        <img src="https://cdn.waityou.online/02d350cc-08b8-a4e8-5fac-a3a73086aa37.png"
             style="width: 50vw"/>
      </nut-row>
    </nut-infiniteloading>
    <nut-backtop :distance="200"></nut-backtop>
  </div>
</template>

<script>
import api from "@/api"
import {Toast} from "@nutui/nutui";

export default {
  name: "InfiniteLoadingList",
  props: {
    loadMoreText: {
      type: String,
      default: '没有更多数据了'
    },
    method: {
      type: String,
      default: 'GET'
    },
    queryId: {
      type: Number,
      default: 0,
    },
    initQuery: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  watch: {
    initQuery() {
      this.refresh()
    }
  },
  data() {
    return {
      hasMore: false,
      page: 0,
      pageSize: 10,
      list: [],
      textMapping:{},
    }
  },
  methods: {
    refresh(done) {
      this.hasMore = true;
      this.page = 0;
      this.list = [];
      this.textMapping = {};
      this.loadMore(done)
    },
    loadMore(done) {
      let query = {
        page: this.page,
        pageSize: this.pageSize
      }
      for (let k of Object.keys(this.initQuery)) {
        query[k] = this.initQuery[k];
      }
      Toast.loading('正在努力加载...');
      api.getInfiniteLoadingList(this.queryId, this.method, query)
          .then(ret => {
            if (ret.page == 0) {
              this.list = [];
            }
            if (ret.list) {
              for (let o of ret.list) {
                this.list.push(o)
              }
            }
            if (!ret || ret.list.length < this.pageSize) {
              this.hasMore = false;
            }
            this.page += 1;
            this.textMapping = ret.textMapping;
            this.$emit('load',this.list)
          })
          .finally(() => {
            if (done) {
              done();
            }
            Toast.hide()
          })
    }
  },
  mounted() {
    this.refresh()
  }
}
</script>

<style lang="scss" scoped>
.InfiniteLoadingListContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
</style>